"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewRange = exports.toTimeZone = exports.convertToDate = exports.formatTime = exports.formatDateIso = exports.formatDate = exports.dateSetTime = exports.parseDateTime = exports.parseTime = exports.parseDateIso = exports.parseDate = exports.defaultMaxDate = exports.defaultMinDate = exports.startOfDayZero = exports.DEFAULT_TIME_FORMAT = exports.DEFAULT_DATE_FORMAT = exports.WEEKDAYS_SHORT = exports.WEEKDAYS_LONG = exports.MONTHS = void 0;
const utcToZonedTime_1 = __importDefault(require("date-fns-tz/utcToZonedTime"));
const addYears_1 = __importDefault(require("date-fns/addYears"));
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
const endOfMonth_1 = __importDefault(require("date-fns/endOfMonth"));
const endOfWeek_1 = __importDefault(require("date-fns/endOfWeek"));
const endOfYear_1 = __importDefault(require("date-fns/endOfYear"));
const format_1 = __importDefault(require("date-fns/format"));
const parse_1 = __importDefault(require("date-fns/parse"));
const set_1 = __importDefault(require("date-fns/set"));
const startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
const startOfMonth_1 = __importDefault(require("date-fns/startOfMonth"));
const startOfWeek_1 = __importDefault(require("date-fns/startOfWeek"));
const startOfYear_1 = __importDefault(require("date-fns/startOfYear"));
const subYears_1 = __importDefault(require("date-fns/subYears"));
__exportStar(require("benjibooks-shared/utils/dateReplacer"), exports);
exports.MONTHS = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
];
exports.WEEKDAYS_LONG = [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
];
exports.WEEKDAYS_SHORT = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
exports.DEFAULT_DATE_FORMAT = "dd.MM.yyyy";
exports.DEFAULT_TIME_FORMAT = "HH:mm";
/** Start of the first day of the Unix epoch (Januar 1, 1970). */
exports.startOfDayZero = (0, startOfDay_1.default)(new Date(0));
/** Default minimum date the user can go back to. */
exports.defaultMinDate = (0, subYears_1.default)(new Date(), 5);
/** Default maximum date the user can go forward to. */
exports.defaultMaxDate = (0, addYears_1.default)(new Date(), 2);
/**
 * Parses the day, month, year and returns a date.
 * The time is the beginning of the day (00:00).
 */
function parseDate(dateStr, format = exports.DEFAULT_DATE_FORMAT) {
    return (0, parse_1.default)(dateStr, format, exports.startOfDayZero);
}
exports.parseDate = parseDate;
/**
 * Parses the day, month, year from the date in ISO format (yyyy-MM-dd).
 */
function parseDateIso(dateStr) {
    return parseDate(dateStr, "yyyy-MM-dd");
}
exports.parseDateIso = parseDateIso;
/**
 * Parses the time in hours and minutes and returns the hours and minutes.
 */
function parseTime(time) {
    if (time == "24:00") {
        return [24, 0];
    }
    else {
        const date = (0, parse_1.default)(time, exports.DEFAULT_TIME_FORMAT, exports.startOfDayZero);
        return [date.getHours(), date.getMinutes()];
    }
}
exports.parseTime = parseTime;
/**
 * Parses the date and time and returns a date.
 */
function parseDateTime(date, time, dateFormat = exports.DEFAULT_DATE_FORMAT) {
    return dateSetTime(parseDate(date, dateFormat), parseTime(time));
}
exports.parseDateTime = parseDateTime;
/**
 * Returns the date with the hours and minutes set to the specified `hoursAndMinutes`.
 *
 * Seconds and milliseconds are set to 0.
 */
function dateSetTime(date, hoursAndMinutes) {
    return (0, set_1.default)(date, {
        hours: hoursAndMinutes[0],
        minutes: hoursAndMinutes[1],
        seconds: 0,
        milliseconds: 0,
    });
}
exports.dateSetTime = dateSetTime;
/**
 * Extracts the day, month, year from the date.
 *
 * If no `format` is defined, the default `dd.MM.yyyy` is used.
 *
 * If `timeZone` is specified, the date is converted to the specified time zone.
 * If no `timeZone` is specified, the date is not converted.
 */
function formatDate(date, options) {
    let { format, timeZone } = options !== null && options !== void 0 ? options : {};
    if (!format) {
        format = exports.DEFAULT_DATE_FORMAT;
    }
    return (0, format_1.default)(timeZone ? toTimeZone(date, timeZone) : date, format);
}
exports.formatDate = formatDate;
/**
 * Extracts the day, month, year from the date in ISO format (yyyy-MM-dd).
 */
function formatDateIso(date, options) {
    return formatDate(date, {
        format: "yyyy-MM-dd",
        timeZone: options === null || options === void 0 ? void 0 : options.timeZone,
    });
}
exports.formatDateIso = formatDateIso;
/**
 * Extracts the hours and minutes from the date.
 *
 * The time `00:00` is returned as `24:00`.
 */
function formatTime(time, options) {
    const { timeZone } = options !== null && options !== void 0 ? options : {};
    const str = (0, format_1.default)(timeZone ? (0, utcToZonedTime_1.default)(time, timeZone) : time, exports.DEFAULT_TIME_FORMAT);
    if (str === "00:00") {
        return "24:00";
    }
    else {
        return str;
    }
}
exports.formatTime = formatTime;
/** Converts an ISO String or a Firestore Timestamp to a JavaScript Date. */
function convertToDate(date) {
    if (typeof date === "string") {
        return new Date(date);
    }
    else {
        return date.toDate();
    }
}
exports.convertToDate = convertToDate;
/**
 * Converts the date to the specified time zone.
 *
 * This is needen, for example, when the server is in a different timezone.
 */
function toTimeZone(date, timeZone) {
    return (0, utcToZonedTime_1.default)(date, timeZone);
}
exports.toTimeZone = toTimeZone;
/** Returns the from and to dates that includes the date and the specified view range. */
function getViewRange(viewRange, date) {
    switch (viewRange) {
        case "day":
            return [(0, startOfDay_1.default)(date), (0, endOfDay_1.default)(date)];
        case "week":
            return [
                (0, startOfWeek_1.default)(date, { weekStartsOn: 1 }),
                (0, endOfWeek_1.default)(date, { weekStartsOn: 1 }),
            ];
        case "month":
            return [(0, startOfMonth_1.default)(date), (0, endOfMonth_1.default)(date)];
        case "year":
            return [(0, startOfYear_1.default)(date), (0, endOfYear_1.default)(date)];
    }
}
exports.getViewRange = getViewRange;
